<template>
  <div id="app">
    <Loader :percentage="percentage" v-if="!loaded && (!ignoreLoader)" class="loader" @complete="onCompletePreloader" />
    <Menu v-if="loaded && (!ignoreLoader)" class="menu" :login="login" />
    <Navigation v-if="loaded && (!ignoreLoader)" />
    <transition appear name="fade">
      <router-view v-if="loaded || ignoreLoader" :login="login" :loginUrl="loginUrl" :checkLogin="checkLogin" class="view" />
    </transition>
    <Footer v-if="loaded && (!ignoreLoader)" />
    <Spotify v-if="loaded && (!isMobileOrSafari) && (!ignoreLoader)" :login="login" />
    <TermsAndPolicy v-if="loaded && !cookiesAnswered" />
  </div>
</template>

<script>
import Loader from '@/components/Loader'
import Menu from '@/components/Menu'
import Navigation from '@/components/Navigation'
import Footer from '@/components/Footer'
import Spotify from '@/components/Spotify'
import TermsAndPolicy from '@/components/TermsAndPolicy'
import ContentLoader from '@/core/ContentLoader'
import { generateRandomString } from '@/core/Utils'

export default {
  name: 'App',
  data () {
    return {
      percentage: 0,
      loaded: false,
      firstLoad: window.firstLoad || true,
      isMobileOrSafari: (this.$browser.name === 'safari' || this.$mobileDetect.mobile()),
      ignoreLoader: this.$route.meta.ignoreLoader
    }
  },
  components: {
    Loader,
    Menu,
    Navigation,
    Footer,
    Spotify,
    TermsAndPolicy
  },
  computed: {
    cookiesAnswered() {
      return this.$storage.get('cookiesAnswered') == 'true'
    }
  },
  watch: {
    $route (value) {
      setTimeout(() => {
        window.scrollTo(0, 1)
      }, 0)
    }
  },
  methods: {
    onProgress (percentage) {
      this.percentage = percentage * 100
    },
    onCompletePreloader () {
      this.loaded = true
    },
    onComplete () {
      // this.loaded = true
      this.percentage = 100
      setTimeout(() => {
        window.scrollTo(0, 1)
      }, 0)
    },

    loginUrl () {
      this.$storage.set('spotifyState', generateRandomString(16))

      return 'https://accounts.spotify.com/authorize' +
        '?response_type=token' +
        '&client_id=' + process.env.SPOTIFY_CLIENT_ID +
        (process.env.SPOTIFY_SCOPES ? '&scope=' + encodeURIComponent('streaming user-modify-playback-state user-read-playback-state playlist-modify-public user-follow-read user-read-private user-read-email') : '') +
        '&redirect_uri=' + encodeURIComponent(process.env.SPOTIFY_REDIRECT_URI) +
        '&state=' + encodeURIComponent(this.$storage.get('spotifyState'))
    },

    login (cb, ignoreMobile) {
      if (!ignoreMobile) {
        if (this.$browser.name === 'safari' || this.$mobileDetect.mobile()) {
          return this.$router.push({ name: 'Home' })
        }
      }

      window.open(this.loginUrl(), 'spotifyLogin', 'width=500,height=500')

      window.spotifyLogin = (data) => {
        this.checkLogin(data, cb)
      }
    },

    checkLogin (data, cb) {
      let spotifyTokenExpiresIn = this.$storage.get('spotifyTokenExpiresIn')
      let now = (new Date()).getTime()
      if (spotifyTokenExpiresIn !== null && now > parseInt(spotifyTokenExpiresIn)) {
        this.$storage.remove('spotifyAccessToken')
      }

      let spotifyAccessToken = this.$storage.get('spotifyAccessToken')
      if (data.access_token) {
        let spotifyState = this.$storage.get('spotifyState')
        if (spotifyState && spotifyState === data.state && spotifyAccessToken !== data.access_token) {
          spotifyAccessToken = data.access_token
          this.$storage.set('spotifyAccessToken', data.access_token)
          this.$storage.set('spotifyTokenExpiresIn', (new Date()).getTime() + (parseInt(data.expires_in) * 60 * 1000))
        }
      }

      if (spotifyAccessToken !== null) {
        this.$nextTick(() => {
          if (cb) {
            cb()
          }
          this.$bus.$emit('spotify-player-ready')
        })
      }
    }
  },
  beforeMount () {
    window.onSpotifyWebPlaybackSDKReady = () => {
      this.$spotifyReady = true
      this.$bus.$emit('spotify-player-ready')
    }

    if (this.firstLoad) {
      this.firstLoad = false
      window.firstLoad = false
      if (this.$route.meta.ignoreLoader) {
        this.onComplete()
      } else {
        ContentLoader.initialize(this.onProgress, this.onComplete)
      }
    }
  }
}
</script>
<style lang="scss">
@import './scss/fonts.scss';
@import './scss/variables.scss';
@import '../node_modules/reset-css/_reset.scss';
@import '../node_modules/flexboxgrid/css/flexboxgrid.css';

body, button, input, select, textarea {
  font-family: 'Objektiv Mk1 Medium';
  outline: none;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  .view {
    min-height: 40vw;
  }
}
.loader {
  z-index: 9999;
}
.menu {
  z-index: 10;
}
.fade-enter-active {
  transition: opacity .5s $authenticMotion;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
* {
  outline: none;
  -moz-osx-font-smoothing: grayscale !important;
  -webkit-font-smoothing: antialiased !important;
}
*:not(input) {
  user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue